var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _rect, _rect2, _rect3, _rect4, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFundsIcon = function SvgFundsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 36,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9FEF5",
    fillRule: "evenodd",
    d: "M24.697 25.535v1.03c0 1.172-.95 2.122-2.122 2.122H11.54a2.122 2.122 0 0 1-2.122-2.122V4.07c0-1.172.95-2.122 2.122-2.122h11.035c1.172 0 2.122.95 2.122 2.122v8.267",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M28.547 27.213h2.948M30.021 25.738v2.949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M.299 5.093h2.064Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6ED9C5",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M.299 5.093h2.064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M1.33 4.061v2.064Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6ED9C5",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M1.33 4.061v2.064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M22.681 24.384v1.03c0 1.171-.95 2.122-2.122 2.122H9.524a2.122 2.122 0 0 1-2.122-2.123V2.92c0-1.172.95-2.122 2.122-2.122H20.56c1.172 0 2.122.95 2.122 2.122v8.266"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    strokeLinecap: "round",
    d: "M13.402 3.047h3.278"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.041,
    cy: 23.384,
    r: 1.355,
    stroke: "#6ED9C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    strokeLinecap: "round",
    d: "M7.367 12.352s-1.082-1.05-2.22-1.05c-1.14 0-2.076.656-1.796 1.999.279 1.342.432 1.909.432 1.909s.848 3.248.416 4.982-.416 5.911 1.385 7.695l-1.916 2.041M12.315 35.025l1.495-2.061s5.523-1.905 6.777-5.448"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.517,
    height: 3.289,
    x: 19.179,
    y: 11.196,
    stroke: "#1A1E22",
    rx: 1.645
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.517,
    height: 3.289,
    x: 19.179,
    y: 14.485,
    stroke: "#1A1E22",
    rx: 1.645
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.517,
    height: 3.289,
    x: 19.179,
    y: 17.774,
    stroke: "#1A1E22",
    rx: 1.645
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.517,
    height: 3.289,
    x: 19.179,
    y: 21.064,
    stroke: "#1A1E22",
    rx: 1.645
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    d: "m12.127 11.125 2.213 2.159 4.644-5.255"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFundsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "funds-icon.00fb8df649f7c222556fe01c68bfe6e3.svg";